import React from "react";
import {
  Routes, // instead of "Switch"
  Route,
} from "react-router-dom";

import Home from "../pages/home";
import About from "../pages/about";
import Services from "../pages/services";
import Faq from "../pages/faq";
import Contact from "../pages/contact";
import Error from "../pages/404";
import NewsEvent from "../pages/news-event";
import InternRegister from "../pages/internship-register";
import SiwesRegister from "../pages/siwes-register";
import Portpolio from "../pages/portfolio";
import BookCall from "../pages/book-call";
import Consultation from "../pages/consultation";
import ProjectsPage from "../pages/about/projects";
import ShareIdea from "../pages/share-idea";
import Community from "../pages/community";

// Import consultation service pages
import MobileAppDevelopment from "../pages/consultation/services/MobileAppDevelopment";
import WebApplicationDevelopment from "../pages/consultation/services/WebApplicationDevelopment";
import AIMachineLearning from "../pages/consultation/services/AIMachineLearning";
import CyberSecurityVAPT from "../pages/consultation/services/CyberSecurityVAPT";
import DevSecOpsPlatformEngineering from "../pages/consultation/services/DevSecOpsPlatformEngineering";
import CTOAsAService from "../pages/consultation/services/CTOAsAService";
import SystemArchitectureSolutionDesign from "../pages/consultation/services/SystemArchitectureSolutionDesign";
import ProductDiscoveryMVPDevelopment from "../pages/consultation/services/ProductDiscoveryMVPDevelopment";
import DigitalTransformation from "../pages/consultation/services/DigitalTransformation";
import PerformanceOptimizationScalability from "../pages/consultation/services/PerformanceOptimizationScalability";
import QualityAssuranceTesting from "../pages/consultation/services/QualityAssuranceTesting";
import OngoingSupportEngineeringPartnership from "../pages/consultation/services/OngoingSupportEngineeringPartnership";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/" exact element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about-us" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/portfolio" element={<Portpolio />} />
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/share-your-idea" element={<ShareIdea />} />
      <Route path="/news" element={<NewsEvent />} />
      <Route path="/community" element={<Community />} />
      <Route path="/intern/register" element={<InternRegister />} />
      <Route path="/siwes/register" element={<SiwesRegister />} />
      <Route path="/book-meeting" element={<BookCall />} />
      <Route path="/consultation" element={<Consultation />} />

      {/* Syrol Services Routes */}
      <Route path="/consultation/mobile-app-development" element={<MobileAppDevelopment />} />
      <Route path="/consultation/web-application-development" element={<WebApplicationDevelopment />} />
      <Route path="/consultation/ai-machine-learning" element={<AIMachineLearning />} />
      <Route path="/consultation/cyber-security-vapt" element={<CyberSecurityVAPT />} />
      <Route path="/consultation/devsecops-platform-engineering" element={<DevSecOpsPlatformEngineering />} />
      <Route path="/consultation/cto-as-a-service" element={<CTOAsAService />} />
      <Route path="/consultation/system-architecture-solution-design" element={<SystemArchitectureSolutionDesign />} />
      <Route path="/consultation/product-discovery-mvp-development" element={<ProductDiscoveryMVPDevelopment />} />
      <Route path="/consultation/digital-transformation" element={<DigitalTransformation />} />
      <Route path="/consultation/performance-optimization-scalability" element={<PerformanceOptimizationScalability />} />
      <Route path="/consultation/quality-assurance-testing" element={<QualityAssuranceTesting />} />
      <Route path="/consultation/ongoing-support-engineering-partnership" element={<OngoingSupportEngineeringPartnership />} />

      <Route path="/about/projects" element={<ProjectsPage />} />

      <Route element={<Error />} />
    </Routes>
  );
};

export default App;
